<template>
  <div class="product-card">
    <buy-one-get-one
      v-if="item.BuyAGetB_promotion"
      v-bind:fromQty="item.BuyAGetB_FromQty"
      v-bind:relatedQty="item.BuyAGetB_RelatedQty"
    ></buy-one-get-one>
    <div class="product_box">
      <div class="ProImg">
        <img v-if="favoritesPage" src="../../assets/img/times.svg" class="pc-fav" @click="deFavoriteProduct(item)" style="cursor: pointer"/>
        <a style="width:100%; height:100%;" @click="goToProductDetail(item)">
          <img
            v-lazy="this.img"
            :key="this.img"
            :src="this.img"
            alt="">
        </a>
      </div>
      <div class="Pro-Details">
        <div class="price-bot">
          <div class="price-marge">
            <div :class="['price__regular', this.isPromotion ? 'promo' : '']">
              <span>${{item ? item.Price.toFixed(2) : ''}}</span>
              <!-- <span class="price-suffix">/ea</span> -->
            </div>
            <div class="price_original" v-show="isPromotion">
              <span>${{item.OriginalPrice ? item.OriginalPrice.toFixed(2) : ''}}</span>
            </div>
             <!-- <div class="price_original">
              <span>${{item.Price ? item.Price.toFixed(2) : ''}}</span>
            </div> -->
          </div>
          <p class="brand-name" @click="onClickBrand">{{this.brand}}</p>
          <p class="ProTitle"><a :href="this.link">{{this.name}}</a></p>

          <div class="review-container-card">
            <div class="star-img-container">
              <img v-for="(item,index) in getStarIndex(this.rating)" :data-index="index" :key="index" class="star-img" :src="item" alt="">
              <p class="star-text">{{this.rating}}</p>
            </div>
          </div>

          <button v-if="isOutOfStock(item)" class="ajax_addto_cart_btn no_stock">{{ $t('outOfStock') }}</button>
          <button
            v-else
            class="ajax_addto_cart_btn"
            @click="throttleAddToCart(item, $event)"
          >
            <span>{{ $t('addToCart') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { flyToElement } from "../../store/modules/cart.js";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../../store/modules/cart";
import star0 from '../../assets/img/star0.jpg'
import star1 from '../../assets/img/star1.jpg'
import star2 from '../../assets/img/star2.jpg'
import busUtil from "../../assets/js/util";
import buyOneGetOne from "../buy-one-get-one/buy-one-get-one";


export default {
  name: 'productCard',
  components: {
    'buy-one-get-one': buyOneGetOne
  },
  props: [
    'img',
    'link',
    'name',
    'brand',
    'isPromotion',
    'price',
    'item',
    'quantity',
    'favoritesPage',
    'rating',
  ],
  data() {
    return {
      list: [],
      found: false,
      num: 0,
      localCount: 0,
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId', 'removeProductFromFavorites']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('cart', ['updateProductCount']),
    ...mapActions('cart',['addProductToCart']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/addCart', item);
        // this.found = true;
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/getCart');
      }
    },
    getItemQuantity: function() {
      if (isUserAuthenticated()) {
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.num = this.cartProductsList.Sales_Order_Lines[i].Quantity;
            this.found = true;
          }
        }
      } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.num = this.cartProductsList[i].quantity;
            this.found = true;
          }
        }
      }
    },
    incrementAddToCart: function(item, add, e) {
      if (add) {
        let quantity = this.num + 1;
        if (isUserAuthenticated()) {
          flyToElement(event.target, $('.cart-link'));
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
          .then(() => {
            this.getItemQuantity();
          })
        } else {
          this.$store.dispatch('cart/addProductToLocalCart', item);
        }
      } else if (!add) {
        let quantity = this.num - 1;
        if (quantity < 1) {
          this.deleteItem(item)
        } else {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
          } else {
            item.quantity = quantity;
            this.$store.dispatch('cart/updateLocalCart', item)
            .then(() => {
              this.$store.dispatch('cart/fetchCartProducts')
            });
          }
        }
      }
    },
    throttleAddToCart:  _.debounce(function(item, e) {
      e.preventDefault();
      busUtil.$emit('addToCartDrop', e, item)
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        }
      });
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
    checkInsideCart() {
      if (isUserAuthenticated()) {
        if (!this.cartProductsList.Sales_Order_Lines.length) {
          this.found = false;
          this.num = 0;
          return;
        }
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            return;
          }
        }
      } else {
        //For whatever reason this portion is necessary for removing the found variable when
        //itemCount is below 1.
        if (!this.cartProductsList.length) {
          this.found = false;
          this.num = 0;
          return;
        } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            }
          }
        }
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount])
          this.$store.dispatch('cart/fetchCartProducts')
        }
      }
    },
    onClickBrand() {
      if (this.brand) {
        if (this.$router.currentRoute.path !== '/collections') {
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewSearch(this.brand, 'Brand');
          }, 600);
        } else {
          this.$root.selectNewSearch(this.brand, 'Brand');
        }
      }
    },
    deFavoriteProduct(item) {
      this.removeProductFromFavorites(item.Product_id)
    },
    getStarIndex(rating) {
      let temp = [];
      if (rating || rating === 0) {
        for (let i=1; i<6; i++) {
          if (rating >= i) {
          temp.push(star2);
          } else if (rating > (i-1) && rating < i) {
          temp.push(star1);
          } else if (rating <= (i-1)) {
          temp.push(star0);
          }
        }
      } else {
        temp = [star0, star0, star0, star0, star0];
      }
      return temp;
    },
  },
  mounted() {
    // Commenting out for now. Keeping in case AFM changes mind.
    // this.checkInsideCart();
    // this.getItemQuantity(this.item);
  },
  beforeUpdate() {
    // Commenting out for now. Keeping in case AFM changes mind.
    // this.checkInsideCart();
    // this.getItemQuantity(this.item);
  },
  computed: mapState({
    cartProductsList: state => state.cart.cartProductsList,
    itemCount: state => state.cart.itemCount,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    windowHeight: state => state.navbar.windowHeight,
    windowWidth: state => state.navbar.windowWidth,
    addToCartLoading: state => state.cart.addToCartLoading
  }),
  watch: {
        // Commenting out for now. Keeping in case AFM changes mind.
    // cartProductsList: function(newVal, oldVal) {
    //   if (newVal !== oldVal || newVal.length !== oldVal.length) {
    //     this.checkInsideCart();
    //     this.getItemQuantity(this.item);
    //   }
    // },
  }
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/productCard.less";
</style>



// WEBPACK FOOTER //
// src/components/product-card/product-card.vue